import i18n from "../locales/index"
import request from "@/utils/request"
const baseurl = process.env.VUE_APP_COMMON_BASE_URL
// 获取OEM信息
export function getOemInfo(query) {
  return request({
    url: baseurl + "/oem",
    method: "get",
    params: query,
  })
}
